import React from "react";

import { Title, Head } from "./Header.style";

function Header() {
  return (
    <Head>
      <Title>Welcome to Memory Game</Title>
    </Head>
  );
}

export default Header;
